import React from "react";

export default ({openPopup, executor, orderStatus, workDidBool, handleAcceptWork}) => {

    if(orderStatus !== 4) return false;
    if(!workDidBool) return false;
    if(executor.status !== 2 && executor.status !== 3) return false;

    return  <div className="actions">
                <div className="button-action big-button acccept-work">
                    <button onClick={() => handleAcceptWork(executor.id)}>Принять работу</button>
                </div>
                <a href="" onClick={(e) => {e.preventDefault(); openPopup(executor)}} className="arbitration">Арбитраж</a>
            </div>
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/AcceptWork.js